import $ from "jquery";

export function initBackToTop(): void {
    const progressPath = document.querySelector<SVGPathElement>(".progress-wrap path");
    if (!progressPath) return;

    const pathLength = progressPath.getTotalLength();

    progressPath.style.transition = "none";
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = String(pathLength);

    // Forza il reflow per applicare la transizione "none" prima di riattivarla
    progressPath.getBoundingClientRect();

    progressPath.style.transition = "stroke-dashoffset 10ms linear";

    const updateProgress = (): void => {
        const scroll = $(window).scrollTop() ?? 0;
        const height = $(document).height()! - $(window).height()!;
        const progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = String(progress);
    };

    updateProgress();
    $(window).on("scroll", updateProgress);

    const offset = 50;

    $(window).on("scroll", function () {
        if ($(this).scrollTop()! > offset) {
            $(".progress-wrap").addClass("active-progress");
        } else {
            $(".progress-wrap").removeClass("active-progress");
        }
    });

    $(".progress-wrap").on("click", function (event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 0);
        return false;
    });
}
